export default "﻿<div class=\"ServiceSelectionView\">\n    <div data-dojo-attach-point=\"tableNode\"></div>\n</div>"